/* 開放日詳情PC版 */
import React, { useState, useEffect } from 'react';
import { useIntl, UserState, useSelector } from 'umi';
import classPrefix from 'prefix-classnames';
import { getWebFosterBreadcrumbItems } from '@/utils/Breadcrumb';
import Breadcrumb from '@/components/Breadcrumb';
import { Spin } from 'antd'; // 添加导入


import './css/WebDetail.less';
import { formatDateTime2 } from '@/utils/dateutils';
import { commonPostRequest } from '@/utils/apiUtils';

const px = classPrefix('web-foster-apply-detail', '-') as (param: string) => string;

// 定义 dataObj 和 applyObj 的类型接口
interface DataObjType {
  appNo: string;
  applicantName: string;
  applicantNameCn: string;
  applicantLastNameCn: string;
  applicantFirstNameCn: string;
  applicantNameEn: string;
  applicantLastNameEn: string;
  applicantFirstNameEn: string;
  applicantGender: number;
  spouseName: string;
  applicantEmail: string;
  applicantCellphone: string;
  applicantAreano: string;
  applicantAddress: string;
  submitTime: string;
  flowStatus: number;
  appResult: string;
  auditRemark: string;
  cancelStatus: number;
  cancelWay: number;
  cancelReason: string;
}

const fetchApplyDetail = async (params?: Record<string, unknown>): Promise<DataObjType[]> => {
  return commonPostRequest<DataObjType[]>('/api/adoptappli/applydetail', params);
};

export default function WebDetail(props: unknown) {
  const intl = useIntl();
  // 在组件内部添加引用
  // 獲取參數 ID
  const urlParams = new URLSearchParams(window.location.search);
  const itemId = urlParams.get('id');
  const [loading, setLoading] = useState<boolean>(true);
  const [dataObj, setDataObj] = useState<DataObjType>({} as DataObjType);
  const { profile } = useSelector(({ user }: { user: UserState }) => user);

  // 請求數據
  useEffect(() => {
    if (!profile || !profile.euid) {
      setLoading(true);
      return undefined;
    }
    const params = {
      id: itemId,
      euid: profile.euid,
    };
    // 请求数据
    fetchApplyDetail(params)
      .then((data) => {
        if (data != null && data.id) {
          setDataObj(data);
        } else {
          window.location.href = '/foster-apply-list?platform=personal';
        }
      })
      .catch((error) => {
        console.error('获取數據失败:', error);
      });
  }, [profile.euid]);

  const getStatusText = (flowStatus: number, cancelStatus?: number): string => {
    // 如果取消状态为1，直接显示已取消
    if (cancelStatus === 1) {
      return intl.formatMessage({ id: '已取消' });
    }
    switch (flowStatus) {
      case 0:
        return intl.formatMessage({ id: '草稿' });
      case 1:
        return intl.formatMessage({ id: '待評估' });
      case 2:
        return intl.formatMessage({ id: '評估完成' });
      default:
        return intl.formatMessage({ id: '未知狀態' });
    }
  };

  // 注釋
  return (
    <Spin spinning={loading}>
      <div className={px('root')}>
        {/* 面包屑 */}
        <div className={px('breadcrumb')}>
          <Breadcrumb itemList={getWebFosterBreadcrumbItems()} />
        </div>
        <div className={px('title')}>
          {intl.formatMessage({ id: '申請成為寄養父母' })}
        </div>
        <div className={px('container')}>
          <div className={px('paragr')}>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '申請編號' })}
              </span>
              <span className={px('paragrContentSpan2')}>{dataObj.appNo}</span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '申請人姓名' })}
              </span>
              <span className={px('paragrContentSpan2')}>{dataObj.applicantName}</span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '配偶姓名' })}
              </span>
              <span className={px('paragrContentSpan2')}>{dataObj.spouseName}</span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '聯繫電話' })}
              </span>
              <span className={px('paragrContentSpan2')}>{dataObj.applicantAreano}-{dataObj.applicantCellphone}</span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '地址' })}
              </span>
              <span className={px('paragrContentSpan2')}>{dataObj.applicantAddress}</span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '申請提交時間' })}
              </span>
              <span className={px('paragrContentSpan2')}>
                {dataObj.submitTime ? formatDateTime2(dataObj.submitTime) : dataObj.submitTime}
              </span>
            </p>
            <p className={px('paragrTitle')}>
              <span className={px('paragrContentSpan1')}>
                {intl.formatMessage({ id: '狀態' })}
              </span>
              <span className={px('paragrContentSpan2')}>
                {getStatusText(dataObj.flowStatus, dataObj.cancelStatus)}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="web-foster-apply-list--footer-button">
        <button
          type="button"
          className="ant-btn ant-btn-default"
          onClick={() => {
            window.location.href = '/foster-apply-list?platform=personal';
          }}
          style={{
            backgroundColor: '#13a07b',
            color: 'white',
            borderColor: '#13a07b',
          }}
        >
          <span>{intl.formatMessage({ id: '返回' })}</span>
        </button>
      </div>
    </Spin>
  );
}
